import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('bs_admin_token');
  if (token) config.headers['Authorization'] = `Bearer ${token}`;
  return config;
});

export const submitLead = (data) => api.post('/leads', data).then((r) => r.data);
export const subscribe = (email) => api.post('/subscribers', { email }).then((r) => r.data);
export const submitApplication = (data) => api.post('/applications', data).then((r) => r.data);

export const adminLogin = (username, password) => api.post('/admin/login', { username, password }).then((r) => r.data);
export const adminMe = () => api.get('/admin/me').then((r) => r.data);
export const adminStats = () => api.get('/admin/stats').then((r) => r.data);
export const adminLeads = () => api.get('/admin/leads').then((r) => r.data);
export const adminUpdateLead = (id, status) => api.patch(`/admin/leads/${id}`, { status }).then((r) => r.data);
export const adminDeleteLead = (id) => api.delete(`/admin/leads/${id}`).then((r) => r.data);
export const adminSubscribers = () => api.get('/admin/subscribers').then((r) => r.data);
export const adminApplications = () => api.get('/admin/applications').then((r) => r.data);
